<template>
  <tr>
    <td>
      <a-checkbox
        @click="SWITCH_WHOLESALES(idx)"
        :checked="$store.state.wholesale.selected.includes(idx)"
      />
    </td>
    <td>
      <b>{{name}}</b>
    </td>
    <td>
      {{location.building}}
      <br />
      <b>{{location.mall}}</b>
      <br />
      <a-badge
        :count="`${location.floor}층 ${location.row}열 ${location.place}호`"
        :numberStyle="{backgroundColor: '#52c41a'} "
      />
    </td>
  </tr>
</template>
<script>
import { TYPES } from "../../stores/wholesale";
import { mapMutations } from "vuex";

export default {
  name: "SaibWholesaleItem",
  props: ["idx", "name", "location"],
  methods: mapMutations([TYPES.SWITCH_WHOLESALES])
};
</script>